import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { imgSrc } from "@/lib/api";

export default function ServicesChapters({ section, base = "" }) {
  const items = section.items || [];
  return (
    <section className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20 py-24 sm:py-32" data-testid="services-section">
      <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="text-xs uppercase font-mono tracking-[0.3em] text-gold">
        {section.eyebrow}
      </motion.p>
      <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-serif font-semibold text-ink tracking-tight">
        {section.title}
      </motion.h2>
      <div className="mt-16 flex flex-col gap-20 sm:gap-28">
        {items.map((item, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className={`grid gap-10 lg:grid-cols-2 lg:gap-16 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
            data-testid={`service-chapter-${i}`}
          >
            <div className="relative">
              <span className="absolute -top-10 -left-2 sm:-left-6 font-mono text-7xl sm:text-8xl text-outline select-none">{item.num}</span>
              <div className="relative overflow-hidden rounded-sm border border-brass/10">
                <img src={imgSrc(item.image)} alt={item.title} className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105 max-h-[80vh]" />
                <div className="absolute inset-0 bg-gradient-to-t from-cast/50 to-transparent" />
              </div>
            </div>
            <div>
              <p className="font-mono text-sm text-flame">{item.num} /</p>
              <h3 className="mt-3 text-2xl sm:text-3xl font-serif text-ink">{item.title}</h3>
              <p className="mt-4 text-base text-ink2 leading-relaxed max-w-lg">{item.text}</p>
              {item.link_label && (
                <Link to={`${base}${item.link || "/contact"}`} data-testid={`service-link-${i}`} className="mt-6 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-gold transition-colors hover:text-flame">
                  {item.link_label} <ArrowUpRight size={16} />
                </Link>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
